import { createAction } from '@wix/communities-blog-client-common';

export const SET_IS_POST_IN_PREVIEW = 'isPostInPreview/SET';

export const setIsPostInPreview = createAction(SET_IS_POST_IN_PREVIEW);
